import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({many: "userOrganizations"})
export class Organization {
	@Field() public id: ID;
	@Field() public name: string;
}



// WEBPACK FOOTER //
// ./src/panels/userProfile/entities/Organization.ts